import {useSelector, useDispatch} from 'react-redux';
import {renderRoutes} from '@computerrock/formation-router';
import {useEffect, useState} from 'react';
import {getJwtToken} from '../utils/saveAdminToken';
import routePaths from '../routePaths';
import {SAVED} from './adminActionTypes';

const ProtectedRoute = ({route, history, ...props}) => {
    const dispatch = useDispatch();
    const {jwtToken} = useSelector(state => ({
        jwtToken: state.admin?.jwtToken ?? null,
    }));
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const storedToken = getJwtToken();
        if (storedToken && !jwtToken) {
            dispatch({
                type: SAVED,
                payload: {jwtToken: storedToken},
            });
            setIsLoading(false);
        } else {
            setIsLoading(false);
            if (!storedToken && !jwtToken) {
                history.push({
                    pathname: routePaths.ADMIN,
                    state: {from: history.location},
                });
            }
        }
    }, [dispatch, jwtToken, history]);

    if (isLoading || !jwtToken) {
        return null;
    }

    return renderRoutes(route.routes, props);
};

export default ProtectedRoute;
